<script>
  import { Input } from '@sveltestrap/sveltestrap';

  export let checked = false;
  export let ref = null;
  export let disabled = null;
</script>

<Input
  aria-disabled={disabled}
  bind:checked
  {disabled}
  bind:inner={ref}
  data-testid="switch-field"
  on:change
  {...$$restProps}
  type="switch"
/>
